import axios from "axios";

const API_URL = `${process.env.REACT_APP_NODE_API}/v-location`;

export const visitorLocationService = (vLocation) => {
  // console.log("location det : ", vLocation);
  return axios.post(
    API_URL,
    { ...vLocation },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
export const getVisitorsLocations = (token) => {
  // console.log("location det : ", token);
  return axios.get(API_URL, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
